import angular from 'angular';

import projectsScopeComponent from './projects-scope.component';
import projectsScopeSearchFilter from './projects-scope-search.filter';

export default angular.module('dbm.dashboard.components.projects-scope', [])
.filter('projectssearch', projectsScopeSearchFilter)
.component('dbmProjectsScope', projectsScopeComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/projecs-scope/index.js